const __WEBPACK_NAMESPACE_OBJECT__ = require("local-storage-fallback");